"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[711],{

/***/ 23207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ Protected; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.2/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(32916);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.2.0_xb7wmhir3y3dgjz5ldeyngzviq/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(41040);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20264);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(49231);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.2.0_xb7wmhir3y3dgjz5ldeyngzviq/node_modules/next/router.js
var next_router = __webpack_require__(60238);
// EXTERNAL MODULE: ../node_modules/.pnpm/next-auth@4.9.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(10780);
// EXTERNAL MODULE: ./src/modules/auth/AuthContext.tsx
var AuthContext = __webpack_require__(26551);
// EXTERNAL MODULE: ./src/stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(62713);
// EXTERNAL MODULE: ./src/ui/index.ts + 13 modules
var ui = __webpack_require__(9242);
;// CONCATENATED MODULE: ./src/modules/layout/components/FullScreenLoading.tsx



var FullScreenLoadingContainer = (0,stitches_config/* styled */.zo)("div", {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    img: {
        width: "250px"
    }
});
var FullScreenLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullScreenLoadingContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/static/img/logo.png",
                alt: "Logo Sigle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                as: "p",
                css: {
                    fontWeight: 600,
                    mt: "$2"
                },
                children: "Loading ..."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/auth/Protected.tsx








var Protected = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var ref = (0,AuthContext/* useAuth */.a)(), user = ref.user, isLegacy = ref.isLegacy, loggingIn = ref.loggingIn;
    var status = (0,next_auth_react.useSession)().status;
    (0,react.useEffect)(function() {
        var checkBnsConfiguration = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var namesResponse, namesJson;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(user && user.username)) {
                                _ctx.next = 13;
                                break;
                            }
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return fetch("https://stacks-node-api.stacks.co/v1/names/".concat(user.username));
                        case 4:
                            namesResponse = _ctx.sent;
                            _ctx.next = 7;
                            return namesResponse.json();
                        case 7:
                            namesJson = _ctx.sent;
                            if (namesJson.zonefile === "") {
                                router.push("/configure-bns");
                            }
                            _ctx.next = 13;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](1);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        11
                    ]
                ]);
            }));
            return function checkBnsConfiguration() {
                return _ref.apply(this, arguments);
            };
        }();
        checkBnsConfiguration();
    }, [
        user
    ]);
    // We show a big loading screen while the user is signing in
    if (loggingIn || status === "loading") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenLoading, {});
    }
    // If user is not logged in
    // If non legacy user doesn't have a session
    if (!user || !isLegacy && status === "unauthenticated") {
        router.push("/login");
        return null;
    }
    if (!user.username) {
        router.push("/register-username");
        return null;
    }
    return children;
};


/***/ }),

/***/ 77776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ Home_Home; },
  "p": function() { return /* reexport */ StoryItem_StoryItem; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.2/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(32916);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.2.0_xb7wmhir3y3dgjz5ldeyngzviq/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(41040);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20264);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(49231);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-toastify@8.2.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(252);
// EXTERNAL MODULE: ./src/modules/layout/components/DashboardLayout.tsx
var DashboardLayout = __webpack_require__(13836);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.2.0_xb7wmhir3y3dgjz5ldeyngzviq/node_modules/next/image.js
var next_image = __webpack_require__(54585);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(62713);
// EXTERNAL MODULE: ./src/ui/index.ts + 13 modules
var ui = __webpack_require__(9242);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(5272);
// EXTERNAL MODULE: ./src/modules/editor/utils/index.ts
var editor_utils = __webpack_require__(6673);
// EXTERNAL MODULE: ../node_modules/.pnpm/fathom-client@3.4.1/node_modules/fathom-client/dist/fathom-client.esm.js
var fathom_client_esm = __webpack_require__(98591);
// EXTERNAL MODULE: ./src/utils/fathom.ts
var fathom = __webpack_require__(13359);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.2.0_xb7wmhir3y3dgjz5ldeyngzviq/node_modules/next/router.js
var next_router = __webpack_require__(60238);
;// CONCATENATED MODULE: ./src/modules/home/components/Home.tsx















var ImgWrapper = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    mx: "auto"
});
var StoryCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
        css: {
            display: "none",
            "@lg": {
                display: "flex",
                gap: "$7",
                p: "$7"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                css: {
                    width: 180,
                    height: 130,
                    backgroundColor: "$gray2",
                    br: "$1"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                direction: "column",
                justify: "between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                        direction: "column",
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                css: {
                                    width: 350,
                                    height: 20,
                                    backgroundColor: "$gray2",
                                    br: "$1"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                css: {
                                    width: 150,
                                    height: 20,
                                    backgroundColor: "$gray2",
                                    br: "$1"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                        direction: "column",
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                css: {
                                    width: 600,
                                    height: 20,
                                    backgroundColor: "$gray2",
                                    br: "$1"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                css: {
                                    width: 500,
                                    height: 20,
                                    backgroundColor: "$gray2",
                                    br: "$1"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Home = function(param) {
    var selectedTab = param.selectedTab, user = param.user, stories = param.stories, loading = param.loading, refetchStoriesLists = param.refetchStoriesLists;
    var ref = (0,react.useState)(false), loadingCreate = ref[0], setLoadingCreate = ref[1];
    var router = (0,next_router.useRouter)();
    var showIllu = !loading && (!stories || stories.length === 0);
    var nbStoriesLabel = loading ? "..." : stories ? stories.length : 0;
    var handleCreateNewPrivateStory = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var storiesFile, story;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoadingCreate(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,utils/* getStoriesFile */.Xc)();
                    case 4:
                        storiesFile = _ctx.sent;
                        story = (0,utils/* createNewEmptyStory */.dP)();
                        storiesFile.stories.unshift((0,editor_utils/* createSubsetStory */.n)(story, {
                            plainContent: ""
                        }));
                        _ctx.next = 9;
                        return (0,utils/* saveStoriesFile */.fS)(storiesFile);
                    case 9:
                        _ctx.next = 11;
                        return (0,utils/* saveStoryFile */.gb)(story);
                    case 11:
                        fathom_client_esm/* trackGoal */.r9(fathom/* Goals.CREATE_NEW_STORY */.J.CREATE_NEW_STORY, 0);
                        router.push("/stories/[storyId]", "/stories/".concat(story.id));
                        _ctx.next = 20;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                        react_toastify_esm/* toast.error */.Am.error(_ctx.t0.message);
                        setLoadingCreate(false);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function handleCreateNewPrivateStory() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashboardLayout/* DashboardLayout */.cl, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Typography */.ZT, {
                size: "h4",
                css: {
                    fontWeight: 600,
                    pb: "$8",
                    mb: "$2",
                    borderBottom: "1px solid $colors$gray6"
                },
                children: selectedTab === "published" ? "Published stories (".concat(nbStoriesLabel, ")") : "Drafts stories (".concat(nbStoriesLabel, ")")
            }),
            showIllu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                css: {
                    mt: "$10"
                },
                align: "center",
                direction: "column",
                children: [
                    selectedTab === "drafts" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 250,
                            height: 94,
                            src: "/static/img/zero_data.gif",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Typography */.ZT, {
                        size: "subheading",
                        css: {
                            mt: "$5",
                            mb: "$3"
                        },
                        children: "You currently have no ".concat(selectedTab === "published" ? "published stories" : "drafts")
                    }),
                    selectedTab === "drafts" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                        variant: "subtle",
                        disabled: loadingCreate,
                        onClick: handleCreateNewPrivateStory,
                        children: !loadingCreate ? "Start writing" : "Creating new story..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryCardSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryCardSkeleton, {})
                ]
            }),
            stories && stories.map(function(story) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryItem_StoryItem, {
                    user: user,
                    story: story,
                    type: selectedTab === "published" ? "public" : "private",
                    refetchStoriesLists: refetchStoriesLists
                }, story.id);
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/modules/auth/AuthContext.tsx
var AuthContext = __webpack_require__(26551);
;// CONCATENATED MODULE: ./src/modules/home/containers/Home.tsx








var Home_Home = function(param) {
    var type = param.type;
    var user = (0,AuthContext/* useAuth */.a)().user;
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(null), stories = ref1[0], setStories = ref1[1];
    var loadStoryFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var file, filter, fileStories;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,utils/* getStoriesFile */.Xc)();
                    case 3:
                        file = _ctx.sent;
                        filter = type === "published" ? "public" : "private";
                        fileStories = file.stories.filter(function(s) {
                            return s.type === filter;
                        });
                        setStories(fileStories);
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        react_toastify_esm/* toast.error */.Am.error(_ctx.t0.message);
                    case 13:
                        _ctx.prev = 13;
                        setLoading(false);
                        return _ctx.finish(13);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9,
                    13,
                    16
                ]
            ]);
        }));
        return function loadStoryFile() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        loadStoryFile();
    }, []);
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {
        selectedTab: type,
        user: user,
        stories: stories,
        loading: loading,
        refetchStoriesLists: loadStoryFile
    });
};

// EXTERNAL MODULE: ../node_modules/.pnpm/nprogress@0.2.0/node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(27811);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.2/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(95124);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.2.0_xb7wmhir3y3dgjz5ldeyngzviq/node_modules/next/link.js
var next_link = __webpack_require__(39397);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/.pnpm/@radix-ui+react-icons@1.1.0_react@17.0.2/node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77385);
// EXTERNAL MODULE: ../node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/format/index.js + 28 modules
var format = __webpack_require__(51304);
;// CONCATENATED MODULE: ./src/modules/home/components/StoryItem.tsx









var StoryContainer = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    borderBottom: "1px solid $colors$gray6",
    py: "$7",
    gap: "$5",
    alignItems: "center",
    "& img": {
        transform: "none",
        transition: "transform .5s .1s"
    },
    "&:hover": {
        "& img": {
            transform: "scale(1.1)",
            transition: "transform .5s .1s"
        },
        "& h4": {
            color: "$gray12"
        }
    }
});
var StoryImage = (0,stitches_config/* styled */.zo)("img", {
    objectFit: "cover",
    objectPosition: "center",
    width: 80,
    height: 58,
    zIndex: -1,
    position: "relative",
    "@md": {
        width: 180,
        height: 130
    }
});
var StoryItem = function(param) {
    var user = param.user, story = param.story, type = param.type, onEdit = param.onEdit, onDelete = param.onDelete, showDeleteDialog = param.showDeleteDialog, deleteLoading = param.deleteLoading, onCancelDelete = param.onCancelDelete, onConfirmDelete = param.onConfirmDelete, onFeature = param.onFeature, showFeatureDialog = param.showFeatureDialog, featureLoading = param.featureLoading, onCancelFeature = param.onCancelFeature, onConfirmFeature = param.onConfirmFeature, onUnFeature = param.onUnFeature, showUnFeatureDialog = param.showUnFeatureDialog, unFeatureLoading = param.unFeatureLoading, onCancelUnFeature = param.onCancelUnFeature, onConfirmUnFeature = param.onConfirmUnFeature;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoryContainer, {
                css: {
                    "@md": {
                        gap: !story.coverImage && story.featured ? "$5" : "$7"
                    }
                },
                children: [
                    !story.coverImage && story.featured && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                        css: {
                            p: "$2",
                            backgroundColor: "$gray1",
                            br: "$round",
                            color: "$orange10"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* StarFilledIcon */.e0l, {})
                    }),
                    story.coverImage && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/stories/[storyId]",
                        as: "/stories/".concat(story.id),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                            css: {
                                borderRadius: "$1",
                                lineHeight: 0,
                                position: "relative"
                            },
                            as: "a",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Box */.xu, {
                                as: "span",
                                css: {
                                    display: "inline-block",
                                    position: "relative",
                                    overflow: "hidden",
                                    borderRadius: "$1",
                                    "&::before": (0,_define_property/* default */.Z)({
                                        content: "",
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "$gray11",
                                        opacity: 0,
                                        transition: ".2s"
                                    }, ".".concat(stitches_config/* darkTheme */.$_, " &"), {
                                        backgroundColor: "$colors$gray1"
                                    }),
                                    "&:hover::before": {
                                        opacity: 0.1
                                    }
                                },
                                children: [
                                    story.featured && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                        css: {
                                            p: "$2",
                                            backgroundColor: "$gray1",
                                            br: "$round",
                                            color: "$orange10",
                                            position: "absolute",
                                            top: "-$2",
                                            right: "-$2"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* StarFilledIcon */.e0l, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryImage, {
                                        src: story.coverImage
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                        direction: "column",
                        css: {
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Box */.xu, {
                                css: {
                                    "@md": {
                                        mb: "$5"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                                        justify: "between",
                                        css: {
                                            gap: "$5",
                                            mb: "$1",
                                            "@md": {
                                                mb: "$2"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/stories/[storyId]",
                                                as: "/stories/".concat(story.id),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                                                        css: {
                                                            fontSize: "$2",
                                                            lineHeight: "20.4px",
                                                            alignSelf: "center",
                                                            fontWeight: 600,
                                                            overflow: "hidden",
                                                            display: "-webkit-box",
                                                            "-webkit-line-clamp": 3,
                                                            "-webkit-box-orient": "vertical",
                                                            textOverflow: "ellipsis",
                                                            "@md": {
                                                                fontSize: "18px",
                                                                lineHeight: "1.5rem",
                                                                "-webkit-line-clamp": 2
                                                            }
                                                        },
                                                        as: "h4",
                                                        children: story.title
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                                                align: "center",
                                                gap: "3",
                                                children: [
                                                    user && story.type === "private" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                                        css: {
                                                            display: "none",
                                                            "@md": {
                                                                backgroundColor: "$gray3",
                                                                py: "$1",
                                                                px: "$3",
                                                                br: "$1",
                                                                fontSize: "$2"
                                                            }
                                                        },
                                                        children: "Draft"
                                                    }),
                                                    user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* DropdownMenu */.h_, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DropdownMenuTrigger */.$F, {
                                                                asChild: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* IconButton */.hU, {
                                                                    css: {
                                                                        alignSelf: "start",
                                                                        p: "$1"
                                                                    },
                                                                    "aria-label": "Story settings",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DotsHorizontalIcon */.nWS, {
                                                                        width: 22,
                                                                        height: 22
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* DropdownMenuContent */.AW, {
                                                                children: [
                                                                    type === "public" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DropdownMenuItem */.Xi, {
                                                                        as: "a",
                                                                        href: "/".concat(user.username, "/").concat(story.id),
                                                                        target: "_blank",
                                                                        rel: "noopener noreferrer",
                                                                        children: "View my story"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DropdownMenuItem */.Xi, {
                                                                        onSelect: onEdit,
                                                                        children: "Edit"
                                                                    }),
                                                                    !story.featured && type === "public" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DropdownMenuItem */.Xi, {
                                                                        onSelect: onFeature,
                                                                        children: "Feature this story"
                                                                    }),
                                                                    story.featured && type === "public" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DropdownMenuItem */.Xi, {
                                                                        onSelect: onUnFeature,
                                                                        children: "Un-feature this story"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DropdownMenuSeparator */.VD, {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DropdownMenuItem */.Xi, {
                                                                        color: "red",
                                                                        onSelect: onDelete,
                                                                        children: "Delete"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/stories/[storyId]",
                                        as: "/stories/".concat(story.id),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Text */.xv, {
                                            size: "xs",
                                            as: "a",
                                            children: [
                                                (0,format/* default */.Z)(story.createdAt, "MMMM dd, yyyy "),
                                                "at",
                                                (0,format/* default */.Z)(story.createdAt, " hh:mmaaa")
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                                css: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/stories/[storyId]",
                                    as: "/stories/".concat(story.id),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                        as: "a",
                                        size: "action",
                                        css: {
                                            display: "none",
                                            "@md": {
                                                overflow: "hidden",
                                                display: "-webkit-box",
                                                "-webkit-line-clamp": 2,
                                                "-webkit-box-orient": "vertical",
                                                textOverflow: "ellipsis",
                                                color: "$gray11"
                                            }
                                        },
                                        children: story.content
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Dialog */.Vq, {
                open: showFeatureDialog,
                onOpenChange: onCancelFeature,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* DialogContent */.cZ, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogTitle */.$N, {
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                                as: "h2",
                                size: "xl",
                                css: {
                                    mb: "$3"
                                },
                                children: "Feature this story"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogDescription */.Be, {
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                children: "This story, once featured, will appear on top of your blog."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                            justify: "end",
                            gap: "6",
                            css: {
                                mt: "$6"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogClose */.GG, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                                        size: "lg",
                                        variant: "ghost",
                                        disabled: featureLoading,
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                                    size: "lg",
                                    color: "orange",
                                    disabled: featureLoading,
                                    onClick: onConfirmFeature,
                                    children: featureLoading ? "Processing ..." : "Confirm"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Dialog */.Vq, {
                open: showUnFeatureDialog,
                onOpenChange: onCancelUnFeature,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* DialogContent */.cZ, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogTitle */.$N, {
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                                as: "h2",
                                size: "xl",
                                css: {
                                    mb: "$3"
                                },
                                children: "Un-feature this story"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogDescription */.Be, {
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                        children: "You\u2019re about to un-feature this story."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                        children: "Would you like to continue?"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                            justify: "end",
                            gap: "6",
                            css: {
                                mt: "$6"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogClose */.GG, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                                        size: "lg",
                                        variant: "ghost",
                                        disabled: unFeatureLoading,
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                                    size: "lg",
                                    color: "orange",
                                    disabled: unFeatureLoading,
                                    onClick: onConfirmUnFeature,
                                    children: unFeatureLoading ? "Processing ..." : "Confirm"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Dialog */.Vq, {
                open: showDeleteDialog,
                onOpenChange: onCancelDelete,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* DialogContent */.cZ, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogTitle */.$N, {
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Heading */.X6, {
                                as: "h2",
                                size: "xl",
                                css: {
                                    mb: "$3"
                                },
                                children: "Delete my story"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogDescription */.Be, {
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                        children: "You\u2019re about to delete your story."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                        children: "Would you like to continue?"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Flex */.kC, {
                            justify: "end",
                            gap: "6",
                            css: {
                                mt: "$6"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* DialogClose */.GG, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                                        size: "lg",
                                        variant: "ghost",
                                        disabled: deleteLoading,
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Button */.zx, {
                                    size: "lg",
                                    color: "orange",
                                    disabled: deleteLoading,
                                    onClick: onConfirmDelete,
                                    children: deleteLoading ? "Deleting ..." : "Confirm"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/home/containers/StoryItem.tsx









var StoryItem_StoryItem = function(param) {
    var user = param.user, story = param.story, type = param.type, refetchStoriesLists = param.refetchStoriesLists;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), showDeleteDialog = ref[0], setShowDeleteDialog = ref[1];
    var ref1 = (0,react.useState)(false), deleteLoading = ref1[0], setDeleteLoading = ref1[1];
    var ref2 = (0,react.useState)(false), showFeatureDialog = ref2[0], setShowFeatureDialog = ref2[1];
    var ref3 = (0,react.useState)(false), featureLoading = ref3[0], setFeatureLoading = ref3[1];
    var ref4 = (0,react.useState)(false), showUnFeatureDialog = ref4[0], setShowUnFeatureDialog = ref4[1];
    var ref5 = (0,react.useState)(false), unFeatureLoading = ref5[0], setUnFeatureLoading = ref5[1];
    var handleEdit = function() {
        router.push("/stories/[storyId]", "/stories/".concat(story.id));
    };
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowDeleteDialog(true);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var file, index;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setDeleteLoading(true);
                        nprogress_default().start();
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,utils/* getStoriesFile */.Xc)();
                    case 5:
                        file = _ctx.sent;
                        index = file.stories.findIndex(function(s) {
                            return s.id === story.id;
                        });
                        if (!(index === -1)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("File not found in list");
                    case 9:
                        file.stories.splice(index, 1);
                        _ctx.next = 12;
                        return (0,utils/* saveStoriesFile */.fS)(file);
                    case 12:
                        _ctx.next = 14;
                        return (0,utils/* deleteStoryFile */.Wb)(story);
                    case 14:
                        _ctx.next = 16;
                        return refetchStoriesLists();
                    case 16:
                        _ctx.next = 21;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](2);
                        react_toastify_esm/* toast.error */.Am.error(_ctx.t0.message);
                    case 21:
                        nprogress_default().done();
                        setDeleteLoading(false);
                        setShowDeleteDialog(false);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    18
                ]
            ]);
        }));
        return function handleConfirmDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelDelete = function() {
        setShowDeleteDialog(false);
    };
    var setFeaturedStory = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(featured) {
            var storyFile, file, oldFeaturedStory, oldFeaturedStoryFile, index;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (featured) {
                            setFeatureLoading(true);
                        } else {
                            setUnFeatureLoading(true);
                        }
                        nprogress_default().start();
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,utils/* getStoryFile */.VW)(story.id);
                    case 5:
                        storyFile = _ctx.sent;
                        storyFile.featured = featured;
                        _ctx.next = 9;
                        return (0,utils/* saveStoryFile */.gb)(storyFile);
                    case 9:
                        _ctx.next = 11;
                        return (0,utils/* getStoriesFile */.Xc)();
                    case 11:
                        file = _ctx.sent;
                        if (!featured) {
                            _ctx.next = 21;
                            break;
                        }
                        oldFeaturedStory = file.stories.find(function(story) {
                            return story.featured;
                        });
                        if (!oldFeaturedStory) {
                            _ctx.next = 21;
                            break;
                        }
                        _ctx.next = 17;
                        return (0,utils/* getStoryFile */.VW)(oldFeaturedStory.id);
                    case 17:
                        oldFeaturedStoryFile = _ctx.sent;
                        oldFeaturedStoryFile.featured = false;
                        _ctx.next = 21;
                        return (0,utils/* saveStoryFile */.gb)(oldFeaturedStoryFile);
                    case 21:
                        index = file.stories.findIndex(function(s) {
                            return s.id === story.id;
                        });
                        if (!(index === -1)) {
                            _ctx.next = 24;
                            break;
                        }
                        throw new Error("File not found in list");
                    case 24:
                        // Only one story can be featured so we remove the old one
                        file.stories.forEach(function(story, index) {
                            if (story.featured) {
                                file.stories[index].featured = false;
                            }
                        });
                        file.stories[index].featured = featured;
                        _ctx.next = 28;
                        return (0,utils/* saveStoriesFile */.fS)(file);
                    case 28:
                        _ctx.next = 30;
                        return refetchStoriesLists();
                    case 30:
                        _ctx.next = 35;
                        break;
                    case 32:
                        _ctx.prev = 32;
                        _ctx.t0 = _ctx["catch"](2);
                        react_toastify_esm/* toast.error */.Am.error(_ctx.t0.message);
                    case 35:
                        nprogress_default().done();
                        if (featured) {
                            setFeatureLoading(false);
                            setShowFeatureDialog(false);
                        } else {
                            setUnFeatureLoading(false);
                            setShowUnFeatureDialog(false);
                        }
                    case 37:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    32
                ]
            ]);
        }));
        return function setFeaturedStory(featured) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFeature = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowFeatureDialog(true);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFeature() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmFeature = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", setFeaturedStory(true));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirmFeature() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelFeature = function() {
        setShowFeatureDialog(false);
    };
    var handleUnFeature = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowUnFeatureDialog(true);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleUnFeature() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmUnFeature = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", setFeaturedStory(false));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleConfirmUnFeature() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelUnFeature = function() {
        setShowUnFeatureDialog(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryItem, {
        user: user,
        story: story,
        type: type,
        onEdit: handleEdit,
        onDelete: handleDelete,
        showDeleteDialog: showDeleteDialog,
        deleteLoading: deleteLoading,
        onConfirmDelete: handleConfirmDelete,
        onCancelDelete: handleCancelDelete,
        onFeature: handleFeature,
        showFeatureDialog: showFeatureDialog,
        featureLoading: featureLoading,
        onConfirmFeature: handleConfirmFeature,
        onCancelFeature: handleCancelFeature,
        onUnFeature: handleUnFeature,
        showUnFeatureDialog: showUnFeatureDialog,
        unFeatureLoading: unFeatureLoading,
        onConfirmUnFeature: handleConfirmUnFeature,
        onCancelUnFeature: handleCancelUnFeature
    });
};

;// CONCATENATED MODULE: ./src/modules/home/index.ts




/***/ }),

/***/ 39551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ AppFooter; }
/* harmony export */ });
/* unused harmony export Footer */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20264);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77385);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55938);
/* harmony import */ var _stitches_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62713);
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9242);





var Footer = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("footer", {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    pt: "$6",
    boxShadow: " 0 0 0 1px $colors$gray6"
});
var AppFooter = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Footer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                css: {
                    mb: "$5"
                },
                gap: "3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .IconButton */ .hU, {
                        as: "a",
                        href: _config__WEBPACK_IMPORTED_MODULE_2__/* .sigleConfig.twitterUrl */ .K.twitterUrl,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TwitterLogoIcon */ .S3E, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .IconButton */ .hU, {
                        as: "a",
                        href: _config__WEBPACK_IMPORTED_MODULE_2__/* .sigleConfig.discordUrl */ .K.discordUrl,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .DiscordLogoIcon */ .dsO, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .IconButton */ .hU, {
                        as: "a",
                        href: _config__WEBPACK_IMPORTED_MODULE_2__/* .sigleConfig.githubUrl */ .K.githubUrl,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .GitHubLogoIcon */ .wGg, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, {
                css: {
                    flexDirection: "column",
                    boxShadow: "0 1px 0 0 $colors$gray6",
                    pb: "$3",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    "@md": {
                        flexDirection: "row"
                    }
                },
                gap: "5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        size: "sm",
                        as: "a",
                        target: "_blank",
                        rel: "noreferrer",
                        href: _config__WEBPACK_IMPORTED_MODULE_2__/* .sigleConfig.blogUrl */ .K.blogUrl,
                        css: {
                            color: "$gray12",
                            "&:hover": {
                                boxShadow: "0 1px 0 0px $colors$gray12"
                            }
                        },
                        children: "Blog"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        size: "sm",
                        as: "a",
                        target: "_blank",
                        rel: "noreferrer",
                        href: _config__WEBPACK_IMPORTED_MODULE_2__/* .sigleConfig.documentationUrl */ .K.documentationUrl,
                        css: {
                            color: "$gray12",
                            "&:hover": {
                                boxShadow: "0 1px 0 0px $colors$gray12"
                            }
                        },
                        children: "Documentation"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        size: "sm",
                        as: "a",
                        target: "_blank",
                        rel: "noreferrer",
                        href: _config__WEBPACK_IMPORTED_MODULE_2__/* .sigleConfig.discordUrl */ .K.discordUrl,
                        css: {
                            color: "$gray12",
                            "&:hover": {
                                boxShadow: "0 1px 0 0px $colors$gray12"
                            }
                        },
                        children: "Support"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        size: "sm",
                        as: "a",
                        target: "_blank",
                        rel: "noreferrer",
                        href: _config__WEBPACK_IMPORTED_MODULE_2__/* .sigleConfig.feedbackUrl */ .K.feedbackUrl,
                        css: {
                            color: "$gray12",
                            "&:hover": {
                                boxShadow: "0 1px 0 0px $colors$gray12"
                            }
                        },
                        children: "Feedback"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                size: "xs",
                css: {
                    py: "$5",
                    color: "$gray12"
                },
                children: [
                    "\xa9 Sigle ",
                    new Date().getFullYear()
                ]
            })
        ]
    });
};


/***/ }),

/***/ 13836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": function() { return /* binding */ FullScreen; },
/* harmony export */   "cl": function() { return /* binding */ DashboardLayout; },
/* harmony export */   "gR": function() { return /* binding */ DashboardSidebar; },
/* harmony export */   "mu": function() { return /* binding */ DashboardContainer; },
/* harmony export */   "vU": function() { return /* binding */ DashboardSidebarNavItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32916);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(90076);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20950);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32895);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_2_0_xb7wmhir3y3dgjz5ldeyngzviq_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41040);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_2_0_xb7wmhir3y3dgjz5ldeyngzviq_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_pnpm_next_12_2_0_xb7wmhir3y3dgjz5ldeyngzviq_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20264);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49231);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39397);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _AppHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21149);
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9242);
/* harmony import */ var _stitches_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62713);
/* harmony import */ var _AppFooter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39551);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60238);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5272);
/* harmony import */ var fathom_client__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98591);
/* harmony import */ var _utils_fathom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13359);
/* harmony import */ var _editor_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6673);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(252);


















var DashboardContainer = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)(_ui__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, {
    flex: 1,
    mt: "$10",
    width: "100%",
    display: "grid",
    "@md": {
        justifyContent: "center",
        gridTemplateColumns: "724px"
    },
    "@lg": {
        gridTemplateColumns: "834px"
    },
    variants: {
        layout: {
            default: {
                "@xl": {
                    gridTemplateColumns: "1fr 826px 1fr"
                }
            },
            wide: {
                gridTemplateColumns: "100%",
                "@lg": {
                    gridTemplateColumns: "834px"
                },
                "@xl": {
                    gridTemplateColumns: "1fr 5fr"
                }
            }
        }
    },
    defaultVariants: {
        layout: "default"
    }
});
var FullScreen = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)("div", {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "space-between"
});
var DashboardSidebar = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)("div", {
    display: "none",
    flexDirection: "column",
    gap: "$3",
    "@xl": {
        display: "flex"
    }
});
var DashboardSidebarNavItem = (0,_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)("a", {
    py: "$3",
    px: "$3",
    br: "$2",
    "&:hover": {
        backgroundColor: "$gray4"
    },
    "&:active": {
        backgroundColor: "$gray5"
    },
    variants: {
        variant: {
            sidebar: {
                alignSelf: "start"
            },
            accordion: {}
        },
        selected: {
            true: {
                backgroundColor: "$gray3"
            }
        }
    },
    defaultVariants: {
        variant: "sidebar"
    }
});
var DashboardLayout = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loadingCreate = ref1[0], setLoadingCreate = ref1[1];
    var handleCreateNewPrivateStory = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_vercel_path0_node_modules_pnpm_next_12_2_0_xb7wmhir3y3dgjz5ldeyngzviq_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var storiesFile, story;
            return _vercel_path0_node_modules_pnpm_next_12_2_0_xb7wmhir3y3dgjz5ldeyngzviq_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoadingCreate(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .getStoriesFile */ .Xc)();
                    case 4:
                        storiesFile = _ctx.sent;
                        story = (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .createNewEmptyStory */ .dP)();
                        storiesFile.stories.unshift((0,_editor_utils__WEBPACK_IMPORTED_MODULE_11__/* .createSubsetStory */ .n)(story, {
                            plainContent: ""
                        }));
                        _ctx.next = 9;
                        return (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .saveStoriesFile */ .fS)(storiesFile);
                    case 9:
                        _ctx.next = 11;
                        return (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .saveStoryFile */ .gb)(story);
                    case 11:
                        fathom_client__WEBPACK_IMPORTED_MODULE_15__/* .trackGoal */ .r9(_utils_fathom__WEBPACK_IMPORTED_MODULE_10__/* .Goals.CREATE_NEW_STORY */ .J.CREATE_NEW_STORY, 0);
                        router.push("/stories/[storyId]", "/stories/".concat(story.id));
                        _ctx.next = 20;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                        react_toastify__WEBPACK_IMPORTED_MODULE_12__/* .toast.error */ .Am.error(_ctx.t0.message);
                        setLoadingCreate(false);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function handleCreateNewPrivateStory() {
            return _ref.apply(this, arguments);
        };
    }();
    var navItems = [
        {
            name: "Drafts",
            path: "/"
        },
        {
            name: "Published",
            path: "/published"
        },
        {
            name: "Analytics",
            path: "/analytics"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FullScreen, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AppHeader__WEBPACK_IMPORTED_MODULE_4__/* .AppHeader */ .t, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DashboardContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, props), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DashboardSidebar, {
                        children: [
                            navItems.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: item.path,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DashboardSidebarNavItem, {
                                        selected: router.pathname === item.path,
                                        children: item.name
                                    })
                                }, item.path);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                                css: {
                                    mt: "$5",
                                    alignSelf: "start"
                                },
                                disabled: loadingCreate,
                                onClick: handleCreateNewPrivateStory,
                                size: "lg",
                                children: !loadingCreate ? "Write a story" : "Creating new story..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_ui__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                        css: {
                            mb: "$5"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_5__/* .Accordion */ .UQ, {
                                css: {
                                    "@xl": {
                                        display: "none"
                                    }
                                },
                                collapsible: true,
                                type: "single",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_ui__WEBPACK_IMPORTED_MODULE_5__/* .AccordionItem */ .Qd, {
                                    value: "item1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_5__/* .AccordionTrigger */ .o4, {
                                            children: (ref = navItems.find(function(item) {
                                                return item.path === router.pathname;
                                            })) === null || ref === void 0 ? void 0 : ref.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_5__/* .AccordionContent */ .vF, {
                                            children: navItems.filter(function(item) {
                                                return item.path !== router.pathname;
                                            }).map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: item.path,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DashboardSidebarNavItem, {
                                                        variant: "accordion",
                                                        children: item.name
                                                    })
                                                }, item.path);
                                            })
                                        })
                                    ]
                                })
                            }),
                            children
                        ]
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AppFooter__WEBPACK_IMPORTED_MODULE_7__/* .AppFooter */ .q, {})
        ]
    });
};



/***/ })

}]);